module.exports = __webpack_public_path__ + "img/verlaine.58738ccd.jpg";